module.exports = __webpack_public_path__ + "img/bycicleMan.c749b1a6.png";